import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "placeholder"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * The `InputDate` field is a form element containing a label and a date input field with an
 * optional placeholder attribute. The date input field is restricted to numeric characters only.
 */
export var InputDate = function InputDate(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Date' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'MM / DD / YYYY' : _ref$placeholder,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label,
    placeholder: placeholder
  }, otherProps, {
    format: "## / ## / ####",
    mask: ['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y'] // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox.
    // Note that we don't use type="date" here
    // as we don't want the default date picker.
    ,
    type: "tel"
  }));
};